export const toCamelCase = (str = '') => `${str[0]?.toUpperCase()}${str?.slice(1).toLowerCase()}`;
